module.exports = __webpack_public_path__ + "images/emoji/woman.efcf3b0b27818c7d8610.png";